var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.87868 4.87868C3.44129 4.31607 4.20435 4 5 4H19C19.7957 4 20.5587 4.31607 21.1213 4.87868C21.6839 5.44129 22 6.20435 22 7V7.98448C22.0001 7.99422 22.0001 8.00395 22 8.01368V17C22 17.7957 21.6839 18.5587 21.1213 19.1213C20.5587 19.6839 19.7957 20 19 20H5C4.20435 20 3.44129 19.6839 2.87868 19.1213C2.31607 18.5587 2 17.7956 2 17V8.01367C1.99986 8.00395 1.99986 7.99422 2 7.98449V7C2 6.20435 2.31607 5.44129 2.87868 4.87868ZM4 9.86852V17C4 17.2652 4.10536 17.5196 4.29289 17.7071C4.48043 17.8946 4.73478 18 5 18H19C19.2652 18 19.5196 17.8946 19.7071 17.7071C19.8946 17.5196 20 17.2652 20 17V9.86852L13.665 14.0919C13.6649 14.0919 13.6648 14.092 13.6647 14.0921C13.1718 14.4208 12.5925 14.5963 12 14.5963C11.4075 14.5963 10.8282 14.4208 10.3353 14.0921C10.3352 14.092 10.3351 14.0919 10.335 14.0919L4 9.86852ZM20 7.46482L12.5553 12.4279L12.555 12.4282C12.3907 12.5378 12.1975 12.5963 12 12.5963C11.8025 12.5963 11.6093 12.5378 11.445 12.4282L11.4447 12.4279L4 7.46482V7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V7.46482Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c09bf069d0cd42350cc0aed623cf02af.svg";
export { ForwardRef as ReactComponent };